
import Vue from "vue";

export default Vue.extend<{}, {}, Computed, {}>({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  computed: {
    reasonQuery() {
      return this.$route.query.reason;
    },
    title() {
      switch (this.reasonQuery) {
        case "notlogin":
          return this.$t('sharedLinkAccessDeniedPage.notLoginTitle');
        case "disabled":
        default:
          return this.$t('sharedLinkAccessDeniedPage.disabledTitle');
      }
    },
    description() {
      switch (this.reasonQuery) {
        case "notlogin":
          return this.$t('sharedLinkAccessDeniedPage.notLoginDescription');
        case "disabled":
        default:
          return this.$t('sharedLinkAccessDeniedPage.disabledDescription');
      }
    },
  },
});

interface Computed {
  reasonQuery: string;
  title: string;
  description: string;
}
